import React, { useEffect } from 'react';

const ContactDetailModal = ({ closeModal, VW }) => {
  // This effect should be inside the modal component
  useEffect(() => {
    document.body.style.overflowY = "hidden";
    return () => {
      document.body.style.overflowY = "auto";
    };
  }, []);

  return (
    <div className="contact_modal_content">
      <div className="contact_modal_header">
        <h4>개인정보 수집 및 이용방침</h4>
        <button onClick={closeModal}></button>
      </div>

      <div className="contact_modal_inner">
        <div className="contact_content_text_wrap">
          <div className="privacy">
            <div className="privacy_0">
              <p>
                개인정보 수집 및 이용방침 (주)키온비트(이하 “데이터파이브”)는
                개인정보를 안전하게 보호하기 위하여 "정보통신망 이용촉진 및
                정보보호 등에 관한 법률"을 비롯한 모든 개인정보보호 규정,
                가이드라인을 준수하고 있습니다. "개인정보 수집 및
                이용방침"이란 이용자의 소중한 개인정보를 보호함으로써 이용자가
                안심하고 서비스를 이용할 수 있도록 데이터파이브가 준수해야 할
                지침을 의미합니다.
              </p>
            </div>

            <div className="privacy_1">
              <strong>1. 개인정보 수집 항목 및 목적</strong>
              <p>
                데이터파이브에서 제공하는 서비스는 서비스를 이용하는 과정에서
                최소한의 개인정보를 수집하고 있습니다.
              </p>
              <dl>
                <dt>구분</dt>
                <dt>수집 항목</dt>
                <dt>이용 목적</dt>
              </dl>
              <dl>
                <dd>문의하기(필수)</dd>
                <dd>이름, 연락처, 이메일, 필요서비스</dd>
                <dd>고객 상담 접수 및 처리</dd>
              </dl>
              <dl>
                <dd>문의하기(선택)</dd>
                <dd>회사명, 직급/소속,일정,의뢰내용</dd>
                <dd>고객 상담 접수 및 처리</dd>
              </dl>
              <dl>
                <dd>기타 서비스 이용(자동)</dd>
                {VW >= 768 ? (
                  <>
                    <dd>
                      서비스 이용기록,접속로그,
                      <br />
                      쿠키,접속 IP정보
                    </dd>
                    <dd>
                      본인 확인 및 서비스 이용 통계,
                      <br />
                      부정이용방지
                    </dd>
                  </>
                ) : (
                  <>
                    <dd>서비스 이용기록,접속로그,쿠키,접속 IP정보</dd>
                    <dd>본인 확인 및 서비스 이용 통계,부정이용방지</dd>
                  </>
                )}
              </dl>
            </div>

            <div className="privacy_2">
              <strong>2. 개인정보 수집 방법</strong>
              <pre>
                개인정보를 수집하는 경우에는 사전에 이용자에게 해당 사실을
                알리고 동의를 구하고 있으며, 아래와 같은 법령에 따라 동의 없이
                이용자의 개인정보를 수집∙이용할수 있습니다.
                <br />
                ① 정보통신서비스의 제공에 관한 계약을 이행하기 위하여 필요한
                개인정보로써 경제적 · 기술적인 사유로 통상적인 동의를 받는
                것이 뚜렷하게 곤란한 경우
                <br />
                ② 부가 서비스 이용 또는 이벤트 응모 과정에서 해당 이용자에게
                개인정보 추가 수집에 대해 동의를 받는 경우 서비스 이용
                과정에서 이용자로부터 아래의 방법을 통해 개인정보가 수집될 수
                있습니다.
                <br />
                ① PC웹, 모바일 웹/앱 이용 과정에서 단말기 정보(OS, 화면
                사이즈, 디바이스 아이디, 휴대폰 기종, 단말기 모델명), IP 주소,
                쿠키, 방문 일시, 부정 이용 기록, 서비스 이용 기록 등의 정보가
                자동으로 생성되어 수집될 수 있습니다.
                <br />② 서비스 이용에 따른 본인 확인 및 개인 식별을 위해 웹
                페이지 등을 통해 이용자의 개인정보가 수집될 수 있습니다.
              </pre>
            </div>

            <div className="privacy_3">
              <strong>3. 개인정보 제공 및 위탁</strong>
              <p>
                데이터파이브는 이용자의 별도 동의가 있는 경우나 법령에 규정된
                경우를 제외하고는 이용자의 개인정보를 제3자에 제공하지
                않습니다.
              </p>
            </div>

            <div className="privacy_4">
              <strong>
                4. 웹사이트 정보 자동 수집 장치(쿠키)에 대한 사항
              </strong>
              <pre>
                쿠키는 웹사이트를 운영하는 데 이용하는 서버가 이용자의
                브라우저로 전송하는 작은 텍스트 파일로, 이용자의 웹사이트 설정
                상태, 방문 기록, 이용 형태를 자동으로 저장하여 웹사이트 사용을
                빠르고 편리하도록 도와주는 역할을 합니다. 쿠키는 이름이나
                전화번호 등 개인을 식별하는 정보를 저장하지 않지만, 이용자
                스스로 쿠키 자동 수집 여부를 선택할 수 있습니다. [쿠키 수집
                거부 설정 방법] ① Internet Explorer : 웹 브라우저 상단의 [도구
                메뉴 &#62; 인터넷 옵션 &#62; 개인정보 &#62; 설정] ② Chrome : 웹
                브라우저 우측의 [설정 메뉴 &#62; 화면 하단의 고급 설정 표시
                &#62; 개인정보의 콘텐츠 설정 버튼 &#62; 쿠키]
              </pre>
            </div>

            <div className="privacy_5">
              <strong>5. 개인정보의 처리 및 이용기간</strong>
              <p>
                데이터파이브는 원칙적으로 개인정보의 수집 및 이용목적 달성
                또는 보유기간이 만료되는 경우, 수집된 개인정보는 열람하거나
                이용할 수 없도록 지체없이 파기 처리합니다. 그 외 관계법령의
                규정에 의하여 보존할 필요가 있는 경우, 일정한 기간 동안 외부와
                차단된 별도의 DB 또는 테이블에 분리 보관합니다.
              </p>
              <nav>
                <dl>
                  <dt>보존 근거</dt>
                  <dt>보존 항목</dt>
                  <dt>보존 기간</dt>
                </dl>
                <dl>
                  {VW >= 768 ? (
                    <>
                      <dd>
                        전자상거래등에서의
                        <br />
                        소비자보호에 관한 법률
                      </dd>
                      <dd>
                        소비자 불만 또는 분쟁
                        <br /> 처리 에 관한 기록
                      </dd>
                      <dd>3년</dd>
                    </>
                  ) : (
                    <>
                      <dd>전자상거래등에서의 소비자보호에 관한 법률</dd>
                      <dd>소비자 불만 또는 분쟁 처리에 관한 기록</dd>
                      <dd>3년</dd>
                    </>
                  )}
                </dl>
                <dl>
                  <dd>통신비밀보호법</dd>
                  <dd>서비스이용관련개인정보</dd>
                  <dd>3개월</dd>
                </dl>
              </nav>
            </div>

            <div className="privacy_6">
              <strong>6. 개인정보의 파기방법</strong>
              <p>
                데이터파이브는 이용자의 개인정보 유출로 인한 피해가 발생하지
                않도록 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수
                없는 기술적 방법을 사용하여 삭제하며, 종이에 출력된 개인정보는
                분쇄기로 분쇄하여 파기합니다.
              </p>
            </div>

            <div className="privacy_7">
              <strong>7. 이용자의 권리</strong>
              <pre>
                ① 정보주체는 데이터파이브에 대해 언제든지 다음 각 호의
                개인정보보호 관련 권리를 행사할 수 있습니다.
                <br />
                &#160;&#160;&#160;&#160;&#160;1&#41; 개인정보 열람요구
                <br />
                &#160;&#160;&#160;&#160;&#160;2&#41; 오류 등이 있을 경우
                개인정보 정정 요구
                <br />
                &#160;&#160;&#160;&#160;&#160;3&#41; 개인정보 삭제 요구
                <br />
                &#160;&#160;&#160;&#160;&#160;4&#41; 개인정보 처리정지 요구
                <br />
                ② 제1항에 따른 권리 행사는 데이터파이브에 대해 개인정보보호법
                시행령 제41조 제1항에 따라 서면, 전자우편, 모사전송(FAX) 등을
                통하여 하실 수 있으며 데이터파이브는 이에 대해 지체 없이
                조치하겠습니다.
                <br />
                ③ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을
                받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우
                개인정보보호법 시행규칙 별지 제11호호 서식에 따른 위임장을
                제출하셔야 합니다.
                <br />
                ④ 개인정보 열람 및 처리정지 요구는 개인정보보호법 제35조
                제5항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수
                있습니다.
                <br />
                ⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가
                수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수
                없습니다.
                <br />
                ⑥ 데이터파이브는 정보주체 권리에 따른 열람의 요구, 정정·삭제의
                요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나
                정당한 대리인인지를 확인합니다.
                <br />
              </pre>
            </div>

            <div className="privacy_8">
              <strong>8. 개인정보 보호책임자 및 담당자</strong>
              <p>
                데이터파이브의 서비스를 이용하면서 발생하는 모든 개인정보보호
                관련 문의, 불만, 조언이나 기타 사항은 개인정보 보호책임자 및
                담당부서로 연락해 주시기 바랍니다. 데이터파이브는 여러분의
                목소리에 귀 기울이고 신속하고 충분한 답변을 드릴 수 있도록
                최선을 다하겠습니다.
              </p>
              <p className="privacy_8_title">개인정보 보호 책임자</p>
              <nav className="privacy_8_nav1">
                <dl>
                  <dt>이름</dt>
                  <dd>이미영</dd>
                </dl>
                <dl>
                  <dt>직책</dt>
                  <dd>CEO</dd>
                </dl>
                <dl>
                  <dt>이메일</dt>
                  <dd>mylee@keyonbit.com</dd>
                </dl>
                <dl>
                  <dt>연락처</dt>
                  <dd>02-6953-0217</dd>
                </dl>
              </nav>

              <p className="privacy_8_nav2_title">
                기타 개인정보침해에 대한 신고나 상담이 필요한 경우 아래 기관에
                문의하시기 바랍니다.
              </p>
              <nav className="privacy_8_nav2">
                <dl>
                  <dt>구분</dt>
                  <dt>웹사이트</dt>
                  <dt>전화번호</dt>
                </dl>
                <dl>
                  <dd>개인정보침해</dd>
                  <dd>신고센터 http://privacy.kisa.or.kr</dd>
                  <dd>국번없이 118</dd>
                </dl>
                <dl>
                  <dd>대검찰청</dd>
                  <dd>사이버수사과 http://www.spo.go.kr</dd>
                  <dd>국번없이 1301</dd>
                </dl>
                <dl>
                  <dd>경찰청</dd>
                  <dd>
                    사이버안전국
                    <br />
                    http://cyberbureau.police.go.kr
                  </dd>
                  <dd>국번없이 182</dd>
                </dl>
              </nav>
            </div>

            <div className="privacy_9">
              <strong>9. 개인정보처리방침의 적용 범위</strong>
              <p>
                데이터파이브의 개인정보처리방침은 데이터파이브
                웹사이트(datafiveco.kr)에 한해 적용됩니다. 데이터파이브에서
                제공하는 다른 회사의 웹사이트 링크로 이동하였을 경우, 해당
                웹사이트의 개인정보처리방침이 적용되니 새로 방문한 웹사이트의
                정책을 반드시 검토하시기 바랍니다.
              </p>
            </div>

            <div className="privacy_10">
              <strong>10. 개인정보처리방침의 변</strong>
              <pre>
                데이터파이브의 개인정보처리방침은 데이터파이브
                웹사이트(datafive.co.kr)에 공개하여 누구나 쉽게 열람할 수
                있도록 하고 있습니다. 법률이나 서비스의 변경사항을 반영하기
                위한 목적 등으로 개인정보취급방침을 수정할 경우, 변경사항을
                게시하며, 변경된 개인정보처리방침은 게시한 날로부터 7일 후부터
                효력이 발생합니다.
                <br />
                시행일자 : 2023년 11월 15일
                <br />※ 귀하께서는 귀하의 개인정보 수집 및 이용에 대한 동의를
                거부하실 권리가 있으며, 동의를 거부하실 경우 서비스 이용에
                제한이 있을 수 있습니다.
              </pre>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactDetailModal;
